import TripCustomer from './TripCustomer';
const {default: DatabaseReference} = require('../platform/DatabaseReference');

export default class Trips extends DatabaseReference {
  get childReferenceType() {
    return TripCustomer;
  }
}
